module.exports = __webpack_public_path__ + "assets/76330f0473d8e8f2fd94c935dff2209b.png";